import React from "react";
import "./Footer.css"; // Ensure you create this CSS file
import { useLanguage } from "../i18n/LanguageContext";


function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <h2 className="footer-logo">Valmis</h2>
        </div>

        <div className="footer-center">
          <h3>{t("footer.contact")}</h3>
          <p>+380 93 800 1306<br/>
          info@valmis.com.ua</p>
        </div>

        <div className="footer-right">
          <h3>{t("footer.newsletterTitle")}</h3>
          <form className="newsletter-form">
            <input
              type="email"
              placeholder={t("footer.emailPlaceholder")}
              required
            />
            <button type="submit">
              {t("footer.contactUs")}
            </button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t("footer.copyright")}</p>
      </div>
    </footer>
  );
}

export default Footer;
